import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  useCallback,
} from 'react';

interface UtilsContextType {
  isUploadFileDialogOpen: boolean;
  openUploadDialog: () => void;
  closeUploadDialog: () => void;
}

const UtilsContext = createContext<UtilsContextType | undefined>(undefined);

interface UtilsProviderProps {
  children: React.ReactNode;
}

export const UtilsProvider: React.FC<UtilsProviderProps> = ({ children }) => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  const openUploadDialog = useCallback(() => {
    console.log('[UtilsContext] Opening Upload Dialog');
    setIsUploadOpen(true);
  }, []);

  const closeUploadDialog = useCallback(() => {
    console.log('[UtilsContext] Closing Upload Dialog');
    setIsUploadOpen(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      isUploadFileDialogOpen: isUploadOpen,
      openUploadDialog,
      closeUploadDialog,
    }),
    [isUploadOpen, openUploadDialog, closeUploadDialog],
  );

  return (
    <UtilsContext.Provider value={contextValue}>
      {children}
    </UtilsContext.Provider>
  );
};

// Создаем кастомный хук для удобного использования контекста
export const useUtils = (): UtilsContextType => {
  const context = useContext(UtilsContext);
  if (context === undefined) {
    throw new Error('useUtils must be used within a UtilsProvider');
  }
  return context;
};
